module.exports = __webpack_public_path__ + "img/泵头.b3ccde2c.svg";